import { ContractAddress } from '../../constants';
import type {
  CommunityContestNFTOptions,
  NFTMetadataInput,
} from '../nft.types';
import { buildNFTs } from '../nft.utils';

export const COMMUNITY_NFT_OPTIONS: CommunityContestNFTOptions = {
  contractAddress: ContractAddress.MogulNftV1,
  label: 'MOGUL_MAJORITY_CONTEST',
  startId: 1,
  count: 1,
  totalSupply: 1697,
  previewMediaIpfsId: 'QmZ6epGR139gN8MhczkhhJw4h9JRVBh8c1tYWMTA2cZ9io',
  rawMediaIpfsId: 'QmRUtwxnRVaikwpbpHVNY3QeQA1mgKGHzc4w59ozTrwgp6',
};

export const buildCommunityContestNftInput = (): NFTMetadataInput => {
  const properties = {
    contract_address: {
      label: 'Contract Address',
      type: 'string',
      value: COMMUNITY_NFT_OPTIONS.contractAddress,
    },
    title: {
      label: 'Title',
      type: 'string',
      value: 'The STARS on the M00n',
    },
    description: {
      label: 'Description',
      type: 'string',
      value: `Vitalik Buterin, CZ from Binance, and Elon Musk are featured with a Mogul STARS token on the moon in this original piece of artwork from Rob Prior. The piece was ideated and voted on by Mogul’s community of NFT Access Pass holders and Rob Prior live-painted the piece of art in front of a live audience.\n\nTo Rob, this piece is special because it allows thousands of holders to get a piece of his work.\n\n"These are the innovators that are setting a whole new movement in motion. It’s my honor to paint them as the heroes they really are.” - Rob Prior\n\nFor this Mogul Productions issued piece, any collector who acquires 50% of the total supply of NFTs will earn a spot in a Mogul-produced movie. A collector who acquires 95% of the total supply will receive 25 million of Mogul’s STARS tokens.`,
    },
    author: { label: 'Author', type: 'string', value: 'Rob Prior' },
    external_url: {
      label: 'External URL',
      type: 'string',
      value: `https://v1.mglnft.com/${COMMUNITY_NFT_OPTIONS.contractAddress.toLowerCase()}/${
        COMMUNITY_NFT_OPTIONS.startId
      }`,
    },
    image_url: {
      label: 'Image URL',
      type: 'string',
      value: `ipfs://${COMMUNITY_NFT_OPTIONS.previewMediaIpfsId}`,
    },
    image_original_url: {
      label: 'Original Image URL',
      type: 'string',
      value: `ipfs://${COMMUNITY_NFT_OPTIONS.rawMediaIpfsId}`,
    },
    media_orientation: {
      label: 'Media Orientation',
      type: 'string',
      value: 'portrait',
    },
    background_color: {
      label: 'Background Color',
      type: 'string',
      value: '000000',
    },
    collection_label: {
      label: 'Collection',
      type: 'string',
      value: 'Mogul Community Contests',
    },
    total_supply: {
      label: 'Total Supply',
      type: 'int',
      value: COMMUNITY_NFT_OPTIONS.totalSupply ?? 1,
    },
    contest: {
      label: 'Contest',
      type: 'string',
      value: 'Majority Collection',
    },
    issue_date: {
      label: 'Issue Date',
      type: 'date',
      value: 1626825600,
    },
  };
  return {
    title: properties.title.value,
    description: properties.description.value,
    properties,
    attributes: Object.keys(properties)
      .filter(k => ['issue_date', 'author', 'contest'].includes(k))
      .map(propertyKey => properties[propertyKey as keyof typeof properties]),
  };
};

export const buildCommunityContestNfts = () => {
  return buildNFTs(COMMUNITY_NFT_OPTIONS, buildCommunityContestNftInput);
};
